import messages from './messages/materialMessages';

export function generateWallEdgingStripMaterials(businessRules, items) {
  const { materials } = businessRules;

  return materials.map((material) => {
    if(material.wallEdgingStrip){
      const { ItemNo: itemNo } = material.wallEdgingStrip;
      return ({
        id: material.id,
        displayName: messages[material.id] || { id: `cwt.materials.${material.id}` },
        wallEdgingStrip: items.find((i) => i.ItemNo === itemNo)
      });
    } else {
      return [];
    }
  }).filter((material) => {
    if(material.length === 0){
      return false;
    }
    if (material.id !== undefined && material.wallEdgingStrip === undefined) {
      // eslint-disable-next-line no-console
      console.error('Excluding wall edging strip for material:', material.id, 'due to no item found');
      return false;
    }
    return true;
  });
}

export function generateWallEdgingStripCustomizableMaterials(businessRules, items) {
  const { materials } = businessRules;

  return materials.map((material) => {
    if(material.wallEdgingStripCustomizable){
      const { ItemNo: itemNo } = material.wallEdgingStripCustomizable;
      return ({
        id: material.id,
        displayName: messages[material.id] || { id: `cwt.materials.${material.id}` },
        wallEdgingStripCustomizable: items.find((i) => i.ItemNo === itemNo)
      });
    } else {
      return [];
    }
  }).filter((material) => {
    if(material.length === 0){
      return false;
    }
    if (material.id !== undefined && material.wallEdgingStripCustomizable === undefined) {
      // eslint-disable-next-line no-console      
      console.error('Excluding wall edging strip customizable for material:', material.id, 'due to no item found');
      return false;
    }
    return true;
  });
}
